import React, { useEffect, useState } from "react";
import { Link } from "react-router";
import {
  MdBusinessCenter,
  MdCalendarMonth,
  MdPhone,
  MdPhoneCallback,
  MdRefresh,
  MdCalendarToday,
  MdWorkspacePremium,
} from "react-icons/md";
import { FaCrown } from "react-icons/fa";
import { getAdminData, rowsForVendorList, isHiddenVendorTestLead, listPageMeta, callbackListRows } from "../../Utils/role";
import {
  getNewLeadList,
  getadminPendingLeadList,
  getLeadList,
} from "../../redux/services/leadServices/Lead.Services";
import { AiCallListByLeadType, getVendorCallbacks } from "../../redux/services/Ai Services/Ai.Services";
import { getSheduleList } from "../../redux/services/Shedule Services/Shedule.Services";
import heroImage from "../../assets/image/crm-dashboard-hero.png";

const listRows = (res) => (Array.isArray(res?.data) ? res.data : []);

const scheduleRows = (res) => {
  const list =
    res?.data?.data?.visits ||
    res?.data?.visits ||
    res?.visits ||
    [];
  return Array.isArray(list) ? list : [];
};

const callRows = (res) => {
  const list = res?.data?.leads || res?.data?.calls || res?.leads || [];
  return (Array.isArray(list) ? list : []).filter((lead) => !isHiddenVendorTestLead(lead));
};

const emptyLane = {
  newLeads: 0,
  pending: 0,
  others: 0,
  schedule: 0,
  calls: 0,
  callbacks: 0,
};

function SplitVendorDashboard() {
  const adminData = getAdminData() || {};
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [work, setWork] = useState(emptyLane);
  const [investment, setInvestment] = useState(emptyLane);

  const loadLane = async (leadType) => {
    const payload = { page: 1, per_page: 100, lead_type: leadType };
    const [newRes, pendingRes, otherRes, callRes, scheduleRes, callbackRes] = await Promise.all([
      getNewLeadList(payload).catch(() => null),
      getadminPendingLeadList(payload).catch(() => null),
      getLeadList(payload).catch(() => null),
      AiCallListByLeadType(leadType, { page: 1, per_page: 100 }).catch(() => null),
      getSheduleList({ lead_type: leadType }).catch(() => null),
      getVendorCallbacks({ lead_type: leadType, page: 1, per_page: 100 }).catch(() => null),
    ]);

    const callbacks = callbackListRows(callbackRes).filter((item) => !isHiddenVendorTestLead(item));

    return {
      newLeads: listPageMeta(newRes, rowsForVendorList(listRows(newRes), leadType, "New").length, 100).total,
      pending: listPageMeta(pendingRes, rowsForVendorList(listRows(pendingRes), leadType, "Pending").length, 100).total,
      others: listPageMeta(otherRes, rowsForVendorList(listRows(otherRes), leadType).length, 100).total,
      calls: listPageMeta(callRes, callRows(callRes).length, 100).total,
      schedule: rowsForVendorList(scheduleRows(scheduleRes), leadType).length,
      callbacks: listPageMeta(callbackRes, callbacks.length, 100).total,
    };
  };

  const load = async (isRefresh = false) => {
    try {
      if (isRefresh) setRefreshing(true);
      else setLoading(true);
      const [workLane, investmentLane] = await Promise.all([
        loadLane("work"),
        loadLane("investment"),
      ]);
      setWork(workLane);
      setInvestment(investmentLane);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const hour = new Date().getHours();
  const greeting =
    hour < 12 ? "Good morning" : hour < 18 ? "Good afternoon" : "Good evening";
  const displayName = adminData?.name || adminData?.username || "Vendor";

  if (loading) {
    return (
      <div className="crm-dashboard-loading">
        <div className="crm-loader-ring" />
        <strong>Preparing your workspace</strong>
        <span>Loading work and investment data…</span>
      </div>
    );
  }

  const lanes = [
    {
      key: "work",
      title: "Work",
      eyebrow: "Work pipeline",
      accent: "#22d3ee",
      data: work,
    },
    // {
    //   key: "investment",
    //   title: "Investment",
    //   eyebrow: "Investment pipeline",
    //   accent: "#a78bfa",
    //   data: investment,
    // },
  ];

  return (
    <div className="crm-dashboard">
      <section className="crm-dashboard-hero">
        <img src={heroImage} alt="" />
        <div className="crm-hero-glow" />
        <div className="crm-hero-content">
          <div className="crm-ai-badge">
            <MdWorkspacePremium size={15} />
            {/* Work and investment workspace */}
             workspace
          </div>
          <h1>
            {greeting}, <span>{displayName}</span>
          </h1>
          <p>
            Leads, schedules and calling history, split for work .
          </p>
          <div className="crm-hero-meta">
            <span>
              <MdCalendarToday size={15} />{" "}
              {new Date().toLocaleDateString("en-IN", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })}
            </span>
            <button onClick={() => load(true)} disabled={refreshing}>
              <MdRefresh className={refreshing ? "crm-spin" : ""} size={16} />
              {refreshing ? "Refreshing" : "Refresh data"}
            </button>
          </div>
        </div>
        <div className="crm-hero-stats">
          <div>
            <span>Work leads</span>
            <strong>{(work.newLeads + work.pending + work.others).toLocaleString("en-IN")}</strong>
            <small>New, pending and others</small>
          </div>
          <div>
            <span>Investment leads</span>
            <strong>{(investment.newLeads + investment.pending + investment.others).toLocaleString("en-IN")}</strong>
            <small>New, pending and others</small>
          </div>
        </div>
      </section>

      {lanes.map((lane) => (
        <section key={lane.key}>
          <div className="crm-section-head">
            <div>
              <span className="crm-eyebrow">{lane.eyebrow}</span>
              <h2>{lane.title}</h2>
            </div>
          </div>
          <div className="crm-kpi-grid">
            <KpiCard
              href={`/new-lead-list?lead_type=${lane.key}`}
              icon={<MdBusinessCenter size={21} />}
              accent={lane.accent}
              value={lane.data.newLeads}
              label={`${lane.title} New Leads`}
              helper="Fresh leads"
            />
            <KpiCard
              href={`/vendor-pending-lead-list?lead_type=${lane.key}`}
              icon={<MdBusinessCenter size={21} />}
              accent="#fbbf24"
              value={lane.data.pending}
              label={`${lane.title} Pending`}
              helper="Need follow-up"
            />
            <KpiCard
              href={`/lead-list?lead_type=${lane.key}`}
              icon={<MdBusinessCenter size={21} />}
              accent="#34d399"
              value={lane.data.others}
              label={`${lane.title} Others`}
              helper="Remaining leads"
            />
            <KpiCard
              href={`/schedule-list?lead_type=${lane.key}`}
              icon={<MdCalendarMonth size={21} />}
              accent="#38bdf8"
              value={lane.data.schedule}
              label={`${lane.title} Schedule`}
              helper="Visits and follow-ups"
            />
            <KpiCard
              href={`/all-calling-list?lead_type=${lane.key}`}
              icon={<MdPhone size={21} />}
              accent="#fb7185"
              value={lane.data.calls}
              label={`${lane.title} Calling History`}
              helper="Calls and outcomes"
            />
            <KpiCard
              href={`/callback-list?lead_type=${lane.key}`}
              icon={<MdPhoneCallback size={21} />}
              accent="#f472b6"
              value={lane.data.callbacks}
              label={`${lane.title} Callbacks`}
              helper="Agreed to be contacted"
            />
          </div>
        </section>
      ))}

      <section>
        <div className="crm-section-head">
          <div>
            <span className="crm-eyebrow">Account</span>
            <h2>Subscription</h2>
          </div>
        </div>
        <div className="crm-kpi-grid">
          <Link
            to="/my-subscriptions"
            className="crm-kpi-card"
            style={{ "--accent": "#fbbf24" }}
          >
            <div className="crm-kpi-top">
              <div className="crm-kpi-icon">
                <FaCrown size={18} />
              </div>
              <span className="crm-kpi-arrow">↗</span>
            </div>
            <div className="crm-kpi-label">My Subscription</div>
            <div className="crm-kpi-helper">View your current plan</div>
            <div className="crm-kpi-line" />
          </Link>
        </div>
      </section>
    </div>
  );
}

function KpiCard({ href, icon, accent, value, label, helper }) {
  return (
    <Link to={href} className="crm-kpi-card" style={{ "--accent": accent }}>
      <div className="crm-kpi-top">
        <div className="crm-kpi-icon">{icon}</div>
        <span className="crm-kpi-arrow">↗</span>
      </div>
      <div className="crm-kpi-value">{Number(value || 0).toLocaleString("en-IN")}</div>
      <div className="crm-kpi-label">{label}</div>
      <div className="crm-kpi-helper">{helper}</div>
      <div className="crm-kpi-line" />
    </Link>
  );
}

export default SplitVendorDashboard;
